import React, { useState, useEffect, ReactNode } from 'react';

import * as Bixby from '$/core';
import { GridService } from '$/services';
import classNames from 'classnames';
import './index.scss';

interface ITransactionDetailsProps {
  transactionDetails: Bixby.Models.CompanyTransactionDetails;
}

const TransactionDetails: React.FC<ITransactionDetailsProps> = props => {
  const { transactionDetails } = props;
  const [rows, setRows] = useState([] as Bixby.Models.CompanyTransactionDetailGridRow[]);

  useEffect(() => {
    if (transactionDetails) {
      setRows(GridService.buildManageCompanyTransactionRow(transactionDetails));
    }
  }, [transactionDetails]);

  const borderWithTopRows = [Bixby.Enums.CompanyTransactionDetailsRowTitles.TotalEnterpriseValueByRevenue];

  const borderWithBottomRows = [
    Bixby.Enums.CompanyTransactionDetailsRowTitles.TotalEnterpriseValueByAdjustedManagementEbitda,
  ];

  const borderBottomRows = [Bixby.Enums.CompanyTransactionDetailsRowTitles.ImpliedEquityAtRisk];

  const tableRows = rows.map((row, index) => {
    const hasBorderWithTop = borderWithTopRows.includes(row.rowTitle);
    const hasBorderWithBottom = borderWithBottomRows.includes(row.rowTitle);
    const hasBorderBottom = borderBottomRows.includes(row.rowTitle);
    return (
      <tr
        key={index}
        className={classNames({
          border_with_top: hasBorderWithTop,
          border_with_bottom: hasBorderWithBottom,
          border_bottom: hasBorderBottom,
        })}>
        <td>{row.name}</td>
        <td>{row.value as ReactNode}</td>
      </tr>
    );
  });
  return (
    <React.Fragment>
      <div className="transaction_details_wrap">
        <table className="table transaction_details_table">
          <thead>
            <tr className="transaction_details_header">
              <th>Original Buyout Details</th>
              <th>($ in MMs)</th>
            </tr>
          </thead>
          <tbody>{tableRows}</tbody>
        </table>
        <p className="italics">{transactionDetails.notes}</p>
      </div>
    </React.Fragment>
  );
};

export default TransactionDetails;
